import {InjectionToken} from '@angular/core';
import {IAppConfig} from './core/config/app-config.interface';

export const PROJECT_CONFIG = new InjectionToken<IAppConfig>('app.config');

export const ProjectConfig: IAppConfig = {
    version: 'v3.0.1',
    appName: 'XPRR',
    appEnv: 'local', // local, UK, US
    apiEndpoint: '',  // not used yet
    dateTimeFormat: 'D MMM Y, HH:mm:ss',
    dateFormat: 'D MMM Y',
    timezone: 'US/Los_Angeles',
    googleClientId: `642492140635-qrl2e3md28ke7u36b9aaf7bfa25q9h8v.apps.googleusercontent.com`
};
